import { useLayoutEffect } from 'react'
import { useAtom } from 'jotai'

type ModalState = {
  isOpen: boolean
  [key: string]: unknown
}

export const useExclusiveModal = (previousModalAtom: any) => {
  const [previousModalValue, setAtomValue] = useAtom<ModalState>(
    previousModalAtom
  )

  useLayoutEffect(() => {
    if (!previousModalValue.isOpen) {
      return
    }

    setAtomValue({
      ...previousModalValue,
      isOpen: false
    })

    return () => {
      setAtomValue({
        ...previousModalValue,
        isOpen: true
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
